module.exports = __webpack_public_path__ + "static/img/trinitas-head.0f5cf7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trinitas-head.png
// module id = 3bze
// module chunks = 1